import React from 'react';

import type { Top } from '@swf/cms';

import styles from '../../styles/styles.scss';

import TopBodyItem from './TopBodyItem';

const CMSTop: React.FC<Top> = ({ body }) => (
  <div className={styles.topContainer}>
    {body.map((item, index) => (
      <TopBodyItem key={index} {...item} />
    ))}
  </div>
);

export default CMSTop;
